/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InspectionResponse } from './InspectionResponse';
import {
    InspectionResponseFromJSON,
    InspectionResponseFromJSONTyped,
    InspectionResponseToJSON,
    InspectionResponseToJSONTyped,
} from './InspectionResponse';
import type { AssetInspectionResponse } from './AssetInspectionResponse';
import {
    AssetInspectionResponseFromJSON,
    AssetInspectionResponseFromJSONTyped,
    AssetInspectionResponseToJSON,
    AssetInspectionResponseToJSONTyped,
} from './AssetInspectionResponse';
import type { InspectionCategoryTypeResponse } from './InspectionCategoryTypeResponse';
import {
    InspectionCategoryTypeResponseFromJSON,
    InspectionCategoryTypeResponseFromJSONTyped,
    InspectionCategoryTypeResponseToJSON,
    InspectionCategoryTypeResponseToJSONTyped,
} from './InspectionCategoryTypeResponse';

/**
 * 
 * @export
 * @interface InspectionsSyncItemsResponse
 */
export interface InspectionsSyncItemsResponse {
    /**
     * 
     * @type {Array<InspectionResponse>}
     * @memberof InspectionsSyncItemsResponse
     */
    inspections?: Array<InspectionResponse>;
    /**
     * 
     * @type {Array<InspectionCategoryTypeResponse>}
     * @memberof InspectionsSyncItemsResponse
     */
    inspectionCategoryTypes?: Array<InspectionCategoryTypeResponse>;
    /**
     * 
     * @type {Array<AssetInspectionResponse>}
     * @memberof InspectionsSyncItemsResponse
     */
    assetInspections?: Array<AssetInspectionResponse>;
}

/**
 * Check if a given object implements the InspectionsSyncItemsResponse interface.
 */
export function instanceOfInspectionsSyncItemsResponse(value: object): value is InspectionsSyncItemsResponse {
    return true;
}

export function InspectionsSyncItemsResponseFromJSON(json: any): InspectionsSyncItemsResponse {
    return InspectionsSyncItemsResponseFromJSONTyped(json, false);
}

export function InspectionsSyncItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionsSyncItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'inspections': json['inspections'] == null ? undefined : ((json['inspections'] as Array<any>).map(InspectionResponseFromJSON)),
        'inspectionCategoryTypes': json['inspectionCategoryTypes'] == null ? undefined : ((json['inspectionCategoryTypes'] as Array<any>).map(InspectionCategoryTypeResponseFromJSON)),
        'assetInspections': json['assetInspections'] == null ? undefined : ((json['assetInspections'] as Array<any>).map(AssetInspectionResponseFromJSON)),
    };
}

export function InspectionsSyncItemsResponseToJSON(json: any): InspectionsSyncItemsResponse {
    return InspectionsSyncItemsResponseToJSONTyped(json, false);
}

export function InspectionsSyncItemsResponseToJSONTyped(value?: InspectionsSyncItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inspections': value['inspections'] == null ? undefined : ((value['inspections'] as Array<any>).map(InspectionResponseToJSON)),
        'inspectionCategoryTypes': value['inspectionCategoryTypes'] == null ? undefined : ((value['inspectionCategoryTypes'] as Array<any>).map(InspectionCategoryTypeResponseToJSON)),
        'assetInspections': value['assetInspections'] == null ? undefined : ((value['assetInspections'] as Array<any>).map(AssetInspectionResponseToJSON)),
    };
}

